import * as tslib_1 from "tslib";
import { Input } from '@angular/core';
import { ComponentMessages } from '@progress/kendo-angular-l10n';
/**
 * @hidden
 */
var Messages = (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Messages;
}(ComponentMessages));
export { Messages };
Messages.propDecorators = {
    'on': [{ type: Input },],
    'off': [{ type: Input },],
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/switch/localization/messages.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/switch/localization/messages.js
// module chunks = 3